import { useCallback } from 'react'
import { useSafeState } from './use-safe-state'

export const useStateArray = initialArray => {
    const [array, setArray] = useSafeState(initialArray)

    const setArrayValue = useCallback(
        (index, update) => {
            setArray(prevArray => {
                const newArray = Array.from(prevArray)
                newArray[index] = typeof update === 'function' ? update(newArray[index]) : update
                return newArray
            })
        },
        [setArray]
    )

    return [array, setArray, setArrayValue]
}
